import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { ApiService } from '../../core/api.service';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';

import { FilterItems, filterItemsResult } from './filter-items.action';

export const filterItemsEpic = (
    action: Observable<PayloadAction<ActionType, FilterItems>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.NOTI__EC__FILTER_ITEMS),
        filter((act: PayloadAction<ActionType, FilterItems>) => {
            const filterOpts = (
                state.value?.notification?.eventCentre as EventCentreDialogState
            )?.filterOpts;
            return (
                filterOpts.dateRange?.from?.getTime() !==
                    act.payload.opts?.dateRange?.from?.getTime() ||
                filterOpts.dateRange?.to?.getTime() !==
                    act.payload.opts?.dateRange?.to?.getTime()
            );
        }),
        switchMap((act: PayloadAction<ActionType, FilterItems>) => {
            const userId = (
                state.value?.notification?.eventCentre as EventCentreDialogState
            )?.userId;
            const service = deps.injector.get<ApiService>(ApiService);

            return service
                .listItems(
                    userId,
                    act.payload.opts?.dateRange?.from,
                    act.payload.opts?.dateRange?.to,
                )
                .pipe(
                    map((ret) => {
                        return filterItemsResult(
                            {
                                ...act.payload,
                                items: ret,
                            },
                            act.storePath,
                        );
                    }),
                    catchError((err) => {
                        console.log(err);
                        return of(null);
                    }),
                );
        }),
    );
